/**
 * useLiens
 * Paginated list of wallet liens with optional filters (status, partnerId).
 *
 * Backend: GET /credit-worker/backoffice/liens
 */

import { useQuery } from '@tanstack/react-query';
import { getLiensList } from '@/services/credit-worker.service';
import type { LiensListFilters } from '@/types/lien.types';

export function useLiens(filters: LiensListFilters = {}) {
  const query = useQuery({
    queryKey: ['lien', 'list', filters.status, filters.partnerId, filters.pageSize, filters.lastKey],
    queryFn: () => getLiensList(filters),
  });

  return {
    items: query.data?.data?.items ?? [],
    nextPageKey: query.data?.data?.nextPageKey ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: () => void query.refetch(),
  };
}
